import { useEffect, useState } from 'react';
import axios from 'axios';
import { Wrench, ExternalLink } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Tools = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    'all',
    'wallets',
    'lightning',
    'exchanges',
    'privacy',
    'explorers',
    'analytics'
  ];

  const categoryLabels = {
    all: 'Todas',
    wallets: 'Carteiras',
    lightning: 'Lightning',
    exchanges: 'Exchanges P2P',
    privacy: 'Privacidade',
    explorers: 'Block Explorers',
    analytics: 'Analytics'
  };

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const response = await axios.get(`${API}/tools`);
        setTools(response.data);
      } catch (error) {
        console.error('Error fetching tools:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTools();
  }, []);

  const filteredTools = selectedCategory === 'all'
    ? tools
    : tools.filter(tool => tool.category === selectedCategory);

  return (
    <div className="min-h-screen py-16" data-testid="tools-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex items-center gap-3 mb-12">
          <Wrench className="text-primary" size={40} />
          <div>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Ferramentas</h1>
            <p className="text-muted-foreground mt-2">Recursos essenciais para o ecossistema Bitcoin</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-sm font-medium transition-colors ${
                selectedCategory === category
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
              data-testid={`category-${category}`}
            >
              {categoryLabels[category]}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-12">Carregando...</div>
        ) : filteredTools.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            Nenhuma ferramenta disponível nesta categoria.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredTools.map((tool) => (
              <a
                key={tool.id}
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-card border border-border rounded-sm p-6 hover:border-primary/50 transition-all duration-300 group"
                data-testid={`tool-card-${tool.id}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-sm flex items-center justify-center">
                    <img src={tool.logo} alt={tool.name} className="w-8 h-8 object-contain" />
                  </div>
                  <ExternalLink className="text-muted-foreground group-hover:text-primary transition-colors" size={20} />
                </div>
                <h3 className="text-xl font-bold mb-2 group-hover:text-primary transition-colors">
                  {tool.name}
                </h3>
                <p className="text-muted-foreground text-sm mb-4">
                  {tool.description}
                </p>
                <span className="bg-primary/10 text-primary px-2 py-1 rounded-sm text-xs font-medium uppercase tracking-wide">
                  {categoryLabels[tool.category]}
                </span>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tools;